import { throwException } from '@app/utils/exceptionHandling';
import axios from 'axios';

export interface FlowParameters {
  flowId: string;
  csrfToken: string;
}

const AUTH_SERVICE_URL =
  window.ENV.AUTH_SERVICE_URL ?? throwException(new Error('window.ENV.AUTH_SERVICE_URL not set'));
const CSRF_TOKEN_INDEX = '0';

let csrfToken = '';
let loginFlowId = '';

async function initialiseLoginFlow(): Promise<void> {
  console.log('Initialising login flow...');
  const response = await axios.get(`${AUTH_SERVICE_URL}/self-service/login/browser`, {
    withCredentials: true,
    headers: {
      Accept: 'application/json',
    },
  });

  loginFlowId = response.data['id'];
  csrfToken = response.data['ui']['nodes'][CSRF_TOKEN_INDEX]['attributes']['value'];
}

function getLoginFlowParameters(): FlowParameters {
  return {
    csrfToken,
    flowId: loginFlowId,
  };
}

async function initialiseRegistrationFlow(): Promise<string> {
  const response = await axios.get(`${AUTH_SERVICE_URL}/self-service/registration/api`, { withCredentials: true });
  const registrationFlowId = response.data['id'];
  return registrationFlowId;
}

const authFlowInitialisationService = { initialiseLoginFlow, getLoginFlowParameters, initialiseRegistrationFlow };

export default authFlowInitialisationService;
